<template>
    <div class="page_head">
		<div style="position: fixed; top: 0; width: 100%;z-index: 9;background: #fff;">
        <head-top></head-top>
        <!-- logo and search -->
        <div class="center_top width_center_1200" @mouseenter="nomodalvisible"><!--  v-show="center_top" -->
            <div class="page_logo">
                <router-link to="/">
                    <h1><img width="154px" height="30px" src="@/assets/createc-logo.png" alt="科瑞达仪器">科瑞达仪器</h1>
                </router-link>
            </div>
            <div class="page_top_seach">
                <ul>
                    <li class="search"><input class="search_input" autocomplete="false" @mouseenter="focusinput" @mouseout="blurinput" @input="focusinput" @blur="blurinput" @focus="focusinput" @keydown="submitSearch($event)" v-model="keywords" type="text"><span id="searchtext">产品搜索</span></li>
                    <li><button class="search_button" type="button" @click="search()"><i
                                class="icon iconfont">&#xeba0;</i></button></li>
                    <li>
                        <div class="index_my_car">
                            <!-- <span @click="to_my_store()">我的商城<i class="icon iconfont">&#xe654;</i></span> -->
                            <span><router-link to="/cart/index">询价车<i class="icon iconfont">&#xe602;</i></router-link>
                                <div class="page_car_dot">{{ cart_count }}</div>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- nav -->
        <div class="page_top_nav">
            <div class="width_center_1200">
                <nav id="navbar" class="navbar">
                    <ul>
                        <li :class="{ 'active': curr_index == 'home' }">
                            <router-link :to="{ path: '/' }" class="nav-link" @mouseover.stop.native="nomodalvisible">首页</router-link>
                        </li>
                        <li class="dropdown" :class="{ 'active': curr_index == 'product' }">
                            <router-link :to="{ path: '/product/category' }" class="nav-link productlink"
                                @mouseover.stop.native="modalvisible" @touchmove.prevent
                                @mousewheel.prevent>产品 <i class="el-icon-arrow-down"></i></router-link>
                        </li>
                        <li :class="{ 'active': curr_index == 'solution' }">
                            <router-link :to="{ path: '/solution' }" class="nav-link" @mouseover.stop.native="nomodalvisible">解决方案</router-link>
                        </li>
                        <li :class="{ 'active': curr_index == 'case' }">
                            <router-link :to="{ path: '/case' }" class="nav-link">客户案例</router-link>
                        </li>
                        <li :class="{ 'active': curr_index == 'news' }">
                            <router-link :to="{ path: '/news' }" class="nav-link">新闻动态</router-link>
                        </li>
                        <li :class="{ 'active': curr_index == 'job' }">
                            <router-link :to="{ path: '/job' }" class="nav-link">人才招聘</router-link>
                        </li>
                        <li class="dropdown" :class="{ 'active': curr_index == 'about' }">
                            <router-link :to="{ path: '/about' }" class="nav-link">关于我们 <i
                                    class="el-icon-arrow-down"></i></router-link>
                            <ul>
                                <li>
                                    <router-link :to="{ path: '/about' }">公司简介</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ path: '/history' }">发展历程</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ path: '/honor' }">资质荣誉</router-link>
                                </li>
                            </ul>
                        </li>
                        <li :class="{ 'active': curr_index == 'contact' }">
                            <router-link :to="{ path: '/contact' }" class="nav-link">联系我们</router-link>
                        </li>
                    </ul>
                    <!-- <i class="el-icon-s-unfold"></i> -->
                </nav>
            </div>
                <div class="products_cascader" v-if="cascaderflag" @mouseleave="nomodalvisible">
                    <div class="products_content" @mouseout="curr_index = ''">
                        <ul>
                            <li v-for="(item, index) in producttype" :key="index">
                                <router-link to="" @mouseenter.native="showlist(item);activeindex = index" :style="{color: index === activeindex?'blue':'#333'}">
                                    <span>{{ item.categoryName }}</span>
                                    <i class="el-icon-arrow-right"></i>
                                </router-link>
                            </li>
                        </ul>
                        <section style="position:absolute;bottom:35px;color:#777;font-size:15px;text-align: left;width: 100%;padding-left: 10px;">
                            <p style="line-height: 28px;height:28px;">
                                专业专注水分析
                            </p>
                            <p style="line-height: 28px;height:28px;">
                                有水必有科瑞达
                            </p>
                            <p style="font-size:18px;color:blue;font-weight:bold;line-height: 40px;"><i class="el-icon-phone" style="margin-right: 10px;"></i>400-666-1916</p>
                        </section>
                    </div>
                    <div class="products_list">
                        <ol>
                            <li v-for="(item, index) in subtype" :key="index" @mouseover="getProducts(item)">
                                <router-link to="">{{ item.categoryName }}<i class="el-icon-arrow-right"></i></router-link>
                                <ol v-if="item.children&&item.children.length===0">
                                    <li v-for="(item2, index2) in productlist[item.id]" :key="index2">
                                        <div class="text" :title="item2.name+'\n'+item2.brief">
                                            <router-link :to="'/product/detail/'+item2.id">{{ item2.name }}</router-link>
                                        </div>
                                    </li>
                                </ol>
                                <div v-if="item.children&&item.children.length>0">
                                    <div v-for="(item2, index2) in item.children" :key="index2">
                                        <router-link to="">{{ item2.categoryName }}<i class="el-icon-arrow-right"></i></router-link>
                                        <ol v-if="item2.children&&item2.children.length===0">
                                            <li v-for="(item3, index3) in productlist[item2.id]" :key="index3">
                                                <div class="text" :title="item3.name+'\n'+item3.brief">
                                                    <router-link :to="'/product/detail/'+item3.id">{{ item3.name }}</router-link>
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </div>
            </div>
        </div>
		</div>
		<div style="height: 160px"></div>
    </div>
</template>

<script>
//import leftBar from "@/components/public/leftbar.vue"
import HeadTop from "@/components/public/head_top.vue"
export default {
    components: {
        //leftBar,
        HeadTop,
    },
    props: {
        subnav_show: {
            type: Boolean,
            default: true,
        },
        change_color: {
            type: Boolean,
            default: false,
        },
        cart_change: {
            type: Number,
        }
    },
    data() {
        return {
            activeindex: 0,
            subnav: true,
            keywords: '',
            cart_count: 0,
            center_top: true,
            curr_index: 'home',
            product: {
                analysis: false,
                pickup: false,
                control: false,
                ecology: false
            },
            producttype: [],
            subtype: [],  // 二级菜单项
            subsubtype: [],  // 三级菜单项
            products: [],  // 对应目录的产品
            productlist: [],
            cascaderflag: false
        }
    },
    watch: {
        subnav_show: function (val) {
            this.subnav = val;
        },
        cart_change: function () {
            this.get_cart_count();
        }
    },
    computed: {},
    methods: {
        handleSelect(key, keyPath) {
            window.console.log(key, keyPath);
        },
        // changeLink: function (index) {
        //     this.curr_index = index;
        // },
        submitSearch(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        },
        search() {
            let params = this.keywords;
            
            if(this.keywords){
                if (this.$route.name == 'product_search_index') {
                    return this.$emit('search_goods', { keywords: this.keywords });
                }else{
                    this.$router.push({path:'/product/search/' + params, query:{word:this.keywords}});
                }
            }else{
                this.$router.push('/product/category')
            }
        },
        get_cart_count: function () {
            if (this.$isEmpty(localStorage.getItem('token'))) {
                return;
            }
            this.$get(this.$api.homeGetCartCount).then(res => {
                this.cart_count = res.data;
            });
        },
        to_my_store: function () {
            if (this.$isEmpty(localStorage.getItem('token'))) {
                this.$message.error('请先登录！');
                return this.$router.push('/user/login');
            }
            this.$get(this.$api.homeIsStore).then(res => {
                if (res.code == 200) {
                    return this.$router.push('/store/' + res.data);
                } else {
                    this.$message.error(res.msg);
                    return this.$router.push('/store/join');
                }
            });
        },
        get_keywords: function () {
            let params = this.$route.params.info;
            if (this.$isEmpty(params)) {
                return;
            }
            let paramsArr = params.split('|');
            paramsArr.forEach(res => {
                let paramsInfo = [];
                paramsInfo = res.split('.');
                if (paramsInfo[0] == 'keywords') {
                    // 搜索关键词
                    if (paramsInfo.length == 2) {
                        this.keywords = paramsInfo[1];
                    } else {
                        this.keywords = '';
                    }
                }
            });
        },
		// 展示产品列表
		modalvisible(){
			this.cascaderflag = true
			this.showlistall()
			document.body.style.overflow='hidden';
            
		},
		// 撤销产品列表
		nomodalvisible(){
			this.cascaderflag = false
			document.body.style.overflow='';//出现滚动条
		},
        //  展示子目录
        showlist(obj) {
            this.subtype = []
            // 展示产品分类子目录
            this.subtype = obj.children
        },
        showlistall() {
            this.subtype = []
            // this.activeindex = 0
            for(let i=0;i<this.producttype.length;i++){
                if(i == this.activeindex){
                    this.subtype = this.producttype[this.activeindex].children
                }
            }
        },
        // 获取产品类型
        getProductTypes() {
            this.producttype = []
            this.$get(this.$api.getProductCategoryTree).then(res => {
                this.producttype = res.data && res.data[0].children
                this.loading = false
            });
        },
        // 获取选择类型下的全部产品
        getproductlist() {
            this.productlist = []
            this.$get(this.$api.getProductsApi).then(res => {
                if (res.code === 0) {
                    this.productlist = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getProducts(obj) {
            if (obj.children && obj.children.length > 0) {
                this.subsubtype = obj.children
            } else {
                const pid = obj.id
                this.products = this.productlist[pid] ? this.productlist[pid] : []
            }
        },
		blurinput(){
			if(!this.keywords){
				document.getElementById('searchtext').style.display='block'
			}else{
				document.getElementById('searchtext').style.display='none';
			}
		},
		focusinput(){
			document.getElementById('searchtext').style.display='none'
		},
    },
    created() {
        this.keywords = this.$route.query.word?this.$route.query.word:''
        this.subnav = this.subnav_show;
        this.get_cart_count();
        this.get_keywords();

        // 获取产品级联目录
        this.getProductTypes()
        // 获取所有产品
        this.getproductlist();

        // 监听滚动条
        window.addEventListener('scroll', () => {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 210) {
                this.center_top = false;
            } else {
                this.center_top = true;
            }
        }, true);

        let curr_url = this.$route.path
        if (curr_url.includes("product")) {
            this.curr_index = 'product';
        } else if (curr_url.includes("solution")) {
            this.curr_index = 'solution';
        } else if (curr_url.includes("case")) {
            this.curr_index = 'case';
        } else if (curr_url.includes("news")) {
            this.curr_index = 'news';
        } else if (curr_url.includes("job")) {
            this.curr_index = 'job';
        } else if (curr_url.includes("about") || curr_url.includes("history") || curr_url.includes("honor")) {
            this.curr_index = 'about';
        } else if (curr_url.includes("contact")) {
            this.curr_index = 'contact';
        } else if (curr_url.includes("search") || curr_url.includes("info")) {
            this.curr_index = 'search';
        } else {
            this.curr_index = 'home';
        }
    },
    mounted() {
    },
    destroyed() {
        window.removeEventListener('scroll', () => { }, true);
    }
};
</script>
<style scoped>
.width_center_1200:after {
    display: none;
}

.page_top_nav .width_center_1200 {
    width: 1280px;
}
</style>
<style lang="scss" scoped>
.page_head {
    z-index: 666;
    // position: fixed;
    background: #fff;
    left: 0;
    right: 0;
}

.center_top {
    width: 1280px;
    padding-left: 0;
    padding-bottom: 30px;
    height: 60px;
    display: block;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page_logo {
    margin-top: 25px;
    margin-bottom: 0px;
}

.page_logo h1 {
    font-size: 30px;
    margin: 0;
    padding: 0;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 2px;
}

.page_logo h1 a,
.page_logo h1 a:hover {
    color: #222222;
    text-decoration: none;
}

.page_logo img {
    padding: 0;
    margin: 0;
    max-height: 30px;
    vertical-align: bottom;
}


.page_top_seach {
    margin-top: 24px;

    ul li {
        float: left;
    }
	
	.search {
		position: relative;
		font-size: 13px;
		color: #aaa;
	}
	
	.search span{
		position: absolute;
		top: 10px;
		left: 15px;
	}

    .search_input {
        width: 300px;
        height: 38px;
        padding: 10px;
        outline: 0;
        border: 1px solid #efefef;
        background: #ffffff;
        border-right: none;
        float: left;
        box-sizing: border-box;
        font-size: 12px;
    }

    .search_input:hover {
        border: 1px solid #a0d2fc;
        background: #ffffff;
    }

    .search_button {
        border: 1px solid #efefef;
        float: left;
        width: 38px;
        height: 38px;
        background: #fff;
        outline: 0;
        text-align: center;
        cursor: pointer;
    }

    .search_button:hover {
        color: #fff;
        background: #ca151e;
    }

    .index_my_car {
        height: 38px;
        border: 1px solid #efefef;
        margin-left: 30px;
        box-sizing: border-box;
        font-size: 12px;
        line-height: 38px;
        padding: 0 20px;

        span:hover {
            color: #ca151e;
        }

        span {
            margin-right: 20px;
            position: relative;

            i {
                font-size: 13px;
                margin-left: 6px;
            }

            a:hover {
                color: #ca151e;
            }

            .page_car_dot {
                position: absolute;
                top: -22px;
                line-height: 16px;
                background: #ca151e;
                padding: 0 4px;
                color: #fff;
                border-radius: 8px;
                right: -15px;
            }
        }

        span:last-child {
            margin-right: 0;

            i {
                font-size: 14px;
            }
        }

    }
}

.page_top_nav {
    height: 40px;
    // background:#333;
    font-size: 14px;
    line-height: 40px;
    //border-bottom: 1px solid rgb(194, 194, 194);
    background: #110af7;
    color: #fff;
    position: relative;
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/**
* Desktop Navigation
*/
.navbar {
    padding: 0;
}

.navbar ul {
    margin: 0;
    padding: 0px;
    display: flex;
    list-style: none;
    align-items: top;
}

.navbar li {
    position: relative;
    padding-top: 15px;
}

.navbar>ul>li {
    white-space: nowrap;
    padding: 0;
}

.navbar a,
.navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    font-size: 14px;
    // font-weight: 600;
    color: #f7f7f7;
    white-space: nowrap;
    transition: 0.3s;
    position: relative;
}

.navbar a i,
.navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
}

.navbar>ul>li>a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -2px;
    left: 0;
    background-color: #106eea;
    visibility: hidden;
    width: 0px;
    transition: all 0.3s ease-in-out 0s;
}

.navbar a:hover:before,
.navbar li:hover>a:before,
.navbar .active:before {
    visibility: visible;
    width: 100%;
}

.navbar .active {
    background: #019ef8;
}

.nav-link:hover {
    color: #ffffff;
    background: #019ef8;
}

.productlink {
    display: inline-block;
}

.navbar .dropdown ul {
    display: block;
    position: absolute;
    //left: 28px;
    top: calc(100% + 30px);
    margin: 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    background: rgb(253, 253, 253);
    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
    padding: 5px 25px 15px 0px;
    // transition: 0.3s;
}

.navbar .dropdown ul li {
    min-width: 200px;
}

.navbar .dropdown ul a {
    color: #333333;
    font-weight: 400;
    height:25px
}

.navbar .dropdown ul a i {
    font-size: 12px;
}

.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover>a {
    color: #0000ff;
}

.navbar .dropdown:hover>ul {
    opacity: 1;
    top: 100%;
    visibility: visible;
}

/* 
.navbar .dropdown .dropdown ul {
    top: 0;
    left: calc(100% - 30px);
    visibility: hidden;
}

.navbar .dropdown .dropdown:hover>ul {
    opacity: 1;
    top: 0;
    left: 100%;
    visibility: visible;
}

@media (max-width: 1366px) {
    .navbar .dropdown .dropdown ul {
        left: -90%;
    }

    .navbar .dropdown .dropdown:hover>ul {
        left: -100%;
    }
} */


//改造产品标签级联
.navbar>ul {
    position: relative
}

.navbar>ul>li {
    height: 40px !important
}

.navbar>ul>li:nth-child(2) {
    position: relative;
    width: 105px;
}

.products_cascader {
    box-shadow: 0 5px 5px #ccc;
    position: relative;
    z-index: 9;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    margin-top: 0;
    // padding-left: calc(calc(100% - 1200px) / 2);
    height: auto !important;
    min-height: 530px;
    max-height: 530px;
    background: #fff;
    display: flex;
    justify-content: center;

    >.products_content {
        position: relative;
        top: 0px;
        padding-left: 0;
        padding-right: 0px;
        height: auto;
        width: 250px;

        >ul {
            position: relative;
            top: 0;
            z-index: 0;
            margin: 0;
            padding-top: 17px;
            padding-bottom: 40px;
            padding-left: 10px;
            visibility: visible;
            opacity: 1;
            box-shadow: 0 0 0 transparent;
            background: #fff;

            li {
                padding-top: 0px;
                padding-bottom: 2px;
                width: 220px;

                a {
                    width: 100%;
                    padding-left: 0;
                    font-weight: bold;
                    height: 20px;
                    line-height: 20px;
                    cursor: text;
                }
            }

            ul {
                top: 0;
                left: calc(100% - 30px);
                visibility: hidden;
            }
        }
    }

    >.products_list {
        width: calc(1220px - 270px);
        height: auto;
        
        min-height: 500px !important;
        max-height: 500px !important;
        overflow-y: auto;
        position: relative;
        margin-top: 15px;
        margin-bottom: 20px;
        padding-left: 20px;
        border-left: 1px dashed #bbb;

        ol {
            position: relative;

            li {
                padding: 0 15px 0 5px;
                color: #333;
                overflow-wrap: break-word;
                overflow: hidden;

                a {
                    color: #333;
                    font-weight: bold;
                    padding: 0 10px;
                    justify-content: flex-start;
                    cursor: text;
                    i {
                        font-weight: bold;
                    }
                }

                >div{
                    >div{
                        >a{
                            display: block;
                            padding-left: 25px;
                            height:25px;
                            line-height: 25px;
                        }
                        li{
                            padding-left: 20px;
                        }
                    }
                    
                }
                ol {
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    padding-left: 10px;

                    li {
                        a{
                            padding-left: 0;
                            font-weight: normal;
                            cursor: pointer;
                            color: #333;
                        }
                        a:hover{
                            color:blue
                        }
                        .text {
                            width: 240px;
                            line-height: 30px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            padding: 5px 10px;
                        }
                    }
                }
            }
        }

        .products {
            padding-left: 10px;

            li {
                height: 30px;
                line-height: 30px;
                color: #000;
            }
        }
    }
}</style>